const tabs = {
  BROWSE_TESTS: 'Browse Tests',
  COMPLETED_TESTS: 'Completed Tests',
  FAQS: 'FAQs',
  MY_PROFILE: 'My Profile',
  VIDEO_INSTRUCTION: 'Video Instruction',
  PRACTICE_TEST_INSTRUCTIONS: 'Practice Test Instructions',
  PRACTICE_TEST: 'Practice Test',
  SETTINGS: 'Settings',
};

export default tabs;
